import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Affix extends Component {

  static propTypes = {
    offset: PropTypes.number,
    position: PropTypes.string,
    bottomOffset: PropTypes.number
  }

  static defaultProps = {
    offset: 0,
    position: 'relative',
    bottomOffset: 0
  }

  constructor() {
    super()
    this.state = {
      affix: false,
      top: 0
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const { affix } = this.state
    const { offset, bottomOffset }  = this.props
    const maxOffset = bottomOffset ? document.body.scrollHeight - bottomOffset - this._affix.clientHeight : Infinity
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

    if (!affix && scrollTop >= offset && scrollTop < maxOffset) {
      this.setState({
        affix: true,
        top: 0
      })
    }

    if (affix && scrollTop < offset) {
      this.setState({
        affix: false,
        top: 0
      })
    }

    if (affix && scrollTop > maxOffset) {
      this.setState({
        affix: false,
        top: maxOffset - offset
      })
    }
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {position, offset, children, bottomOffset, ...rest} = this.props
    /* eslint-enable no-unused-vars */
    const { affix, top } = this.state
    return (
      <div style={{position: affix ? 'fixed' : position, top}} {...rest} ref={affix => this._affix = affix}>
        {children}
      </div>
    )
  }
}

export default Affix
